import { useState, useEffect } from "react";
import { getAuthHeader } from "../../utils/security";
import { urlPath } from "../Settings";
import { setCurrentVersion } from "../Helpers";

const useFileList = props => {
  const { admaterial, matspec, updateMaterial } = props;
  const [materials, setMaterials] = useState([]);
  const [data, setData] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const onSwitchChange = (checked, e) => {
    setIsChecked(checked);
    setCurrentVersion(matspec, e.target.value);
    const val = parseInt(e.target.value, 10);
    const material = materials.filter(material => material.id === val);
    setTimeout(() => {
      updateMaterial(material[0], matspec);
    }, 1000);
  };
  useEffect(() => {
    async function getAdMaterials() {
      if (!admaterial && matspec) {
        const response = await fetch(
          urlPath +
            "/api/loadadmaterials?matspec=" +
            matspec +
            "&timezone=" +
            Intl.DateTimeFormat().resolvedOptions().timeZone,
          {
            credentials: "include",
            headers: getAuthHeader()
          }
        );
        const data = await response.json();
        setData(data);
        setMaterials(data.admaterial.reverse());
      } else {
        setMaterials([admaterial]);
      }
    }
    getAdMaterials();
  }, [admaterial, matspec]);
  return { materials, onSwitchChange, data, isChecked };
};

export default useFileList;



// WEBPACK FOOTER //
// ./src/components/FileList/useFileList.js